import React from 'react';

import styles from './allocatorProfileSectionHeaderStyles';

import Icon from 'buyside/components/presentation/Icon/icon';
import ProfileSectionVisibilityTag from 'buyside/components/presentation/ProfileSectionVisibilityTag/profileSectionVisibilityTag';
import Button, { BUTTON_TYPES } from 'buyside/components/presentation/Button/button';

import EyeIcon from 'SVGs/eye';
import PencilIcon from 'buyside/svgs/pencil.svg';

const AllocatorProfileSectionHeader = ({
  icon,
  title,
  sectionVisibility,
  openEditModal,
  isAdmin
}) => {
  return (
    <div className={styles.sectionHeader}>
      <div className={styles.sectionHeaderHeading}>
        <Icon type={icon} />
        <span>{title}</span>
        {sectionVisibility === 'admin' && (
          <ProfileSectionVisibilityTag icon={EyeIcon} visibility="SumZero Admins" />
        )}
      </div>
      <div>
        {isAdmin && openEditModal && (
          <Button
            text="Edit"
            onClick={openEditModal}
            className={styles.sectionHeaderEditButton}
            type={BUTTON_TYPES.LINK}
            icon={PencilIcon}
            iconStyle={styles.editButtonIcon}
          />
        )}
      </div>
    </div>
  );
};

export default AllocatorProfileSectionHeader;
